import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=2feaaaea&scoped=true&"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=2feaaaea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feaaaea",
  null
  
)

export default component.exports